import { ReadOnlyItem, Text } from '@ydistri/ds';
import React from 'react';
import { formatNumber } from '@ydistri/generic-utils';
import { NO_VALUE } from '../../../lib/utils/utilsTypes';

interface PriceProps {
  price?: number | string | null;
  label: string;
  currency: string;
  labelWidth?: string;
  suffix?: React.ReactNode;
  spaceBetweenLabelAndValue?: string;
}

/**
 * Component to display a price with a label and a currency.
 * Rendered using a ReadOnlyItem with a labelWidth of 6rem.
 * @param price
 * @param label
 * @param currency
 * @param labelWidth Width of the label, defaults to 6rem
 * @param suffix To be displayed after the price
 * @param spaceBetweenLabelAndValue Gap between label and value, defaults to 1rem
 * @constructor
 */
const Price: React.FC<PriceProps> = ({
  price,
  label,
  currency,
  labelWidth = '6rem',
  suffix,
  spaceBetweenLabelAndValue,
}) => {
  return (
    <ReadOnlyItem
      label={label}
      plainLabel
      labelWidth={labelWidth}
      spaceBetween={spaceBetweenLabelAndValue}
    >
      <Text $semiBold>{price ? `${formatNumber(price, 2)} ${currency}` : NO_VALUE}</Text>
      {suffix}
    </ReadOnlyItem>
  );
};

export default Price;
